// Turkish
export const tr = {
  'app.name':           'Kardolive',
  'app.tagline':        'Müşteri portalı',
  'app.signOut':        'Çıkış',

  'login.email':        'E-posta',
  'login.password':     'Şifre',
  'login.signIn':       'Giriş yap',
  'login.signingIn':    'Giriş yapılıyor…',
  'login.failed':       'Giriş başarısız',
  'login.newAccount':   'Kardolive\'a yeni misiniz?',
  'login.createAccount':'Ücretsiz hesap oluşturun →',

  'nav.workspace':      'Çalışma alanı',
  'nav.templates':      'Şablonlar',
  'nav.live':           'Canlı',
  'nav.rooms':          'Odalar ve sohbet',
  'nav.content':        'İçerik',
  'nav.developer':      'Geliştirici',
  'nav.account':        'Hesap',

  'nav.overview':       'Genel bakış',
  'nav.projects':       'Projeler',
  'nav.chat':           'Sohbet konsolu',
  'nav.sessions':       'Oturumlar',
  'nav.streams':        'Canlı yayınlar',
  'nav.studio':         'Stüdyo',
  'nav.recordings':     'Kayıtlar',
  'nav.apiKeys':        'API anahtarları',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Webhook test aracı',
  'nav.networkTest':    'Ağ testi',
  'nav.embed':          'Gömülü widget\'lar',
  'nav.sdk':            'SDK ve dokümanlar',
  'nav.docs':           'Geliştirici dokümanları',
  'nav.analytics':      'Analiz',
  'nav.settings':       'Ayarlar',

  'overview.welcome':       'Tekrar hoş geldiniz, {name}',
  'overview.plan':          '{tenant} · {plan} planı',
  'overview.newStream':     'Yeni yayın',
  'overview.kpi.live':           'Şu anda canlı',
  'overview.kpi.live.broadcasting': 'yayın sürüyor',
  'overview.kpi.live.nothing':    'canlı yok',
  'overview.kpi.total':           'Toplam yayın',
  'overview.kpi.total.sub':       'tüm zamanlar',
  'overview.kpi.sessions':        'Oturumlar · 30 gün',
  'overview.kpi.sessions.sub':    'yayın olayları',
  'overview.kpi.recordings':      'Kayıtlar',
  'overview.kpi.recordings.sub':  'oynatmaya hazır',
  'overview.recentStreams':       'Son yayınlar',
  'overview.recentSessions':      'Son oturumlar',
  'overview.viewAll':             'Tümünü gör →',
  'overview.empty.title':         'Henüz yayın yok',
  'overview.empty.body':          'Yayına başlamak için ilk yayınınızı oluşturun.',
  'overview.empty.action':        'Yayın oluştur',
  'overview.noSessions':          'Henüz oturum yok',

  'status.live':        'CANLI',
  'status.idle':        'BOŞTA',
  'status.ended':       'BİTTİ',
  'status.archived':    'ARŞİVLENDİ',

  'common.save':        'Kaydet',
  'common.cancel':      'İptal',
  'common.delete':      'Sil',
  'common.edit':        'Düzenle',
  'common.create':      'Oluştur',
  'common.confirm':     'Onayla',
  'common.loading':     'Yükleniyor…',
  'common.error':       'Hata',
  'common.retry':       'Tekrar dene',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Sayfa içeriğine geç",
  "nav.streamTemplates": "Yayın şablonları",
  "nav.boards": "Etkileşimli tahtalar",
  "nav.menu": "Gezinmeyi aç",
  "nav.closeMenu": "Gezinmeyi kapat",
  "nav.scenarios": "Senaryolar",
  "nav.premieres": "Prömiyerler",
  "nav.clips": "Klipler",
  "dashboard.account": "Hesap",
  "dashboard.language": "Dil",
  "dashboard.appearance": "Görünüm",
  "nav.allStreams": "Tüm yayınlar",
  "nav.destinations": "Hedefler",
  "nav.ecommerce": "E-ticaret",
  "nav.products": "Ürünler",
  "nav.services": "Hizmetler",
  "nav.collections": "Koleksiyonlar",
  "nav.orders": "Siparişler",
  "nav.commerceSettings": "Ticaret ayarları",
  "nav.engagement": "Etkileşim",
  "theme.light": "Açık moda geç",
  "theme.dark": "Koyu moda geç",
  "role.owner": "Sahip",
  "role.admin": "Yönetici",
  "role.member": "Üye",
  "role.viewer": "İzleyici",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Etkin",
  "streams.archived": "Arşivlenen",
  "streams.monitor": "Kaynak izleyici",
  "streams.create": "Canlı yayın oluştur",
  "streams.list": "Liste",
  "streams.grid": "Izgara",
  "streams.view": "Yayın görünümü",
  "streams.searchLabel": "Etkinlik ara",
  "streams.searchHint": "Ada göre ara",
  "streams.solutionFilter": "Etkinlikleri türe göre filtrele",
  "streams.statusFilter": "Etkinlikleri duruma göre filtrele",
  "streams.dateFilter": "Oluşturulma tarihine göre filtrele",
  "streams.allSolutions": "Tüm türler",
  "streams.custom": "Mevcut veya özel kurulum",
  "streams.allStatuses": "Tüm durumlar",
  "streams.anyTime": "Herhangi bir oluşturulma tarihi",
  "streams.last7": "Son 7 günde oluşturulan",
  "streams.last30": "Son 30 günde oluşturulan",
  "streams.count": "{total} etkinlikten {shown} tanesi gösteriliyor",
  "streams.noMatch": "Filtrelere uyan etkinlik yok.",
  "streams.clearFilters": "Filtreleri temizle",
  "streams.refreshFailed": "Yayın listesi yenilenemedi",
  "streams.loadFailed": "Yayınlar yüklenemedi",
  "streams.stale": "Son yüklenen liste gösteriliyor. Durumlar değişmiş olabilir.",
  "streams.connectionHint": "Bağlantınızı kontrol edip listeyi yeniden yükleyin.",
  "streams.retrying": "Yeniden deneniyor…",
  "streams.retry": "Tekrar dene",
  "streams.restoreFailed": "Yayın geri yüklenemedi",
  "streams.restoreHint": "Tekrar denemeden önce bağlantınızı kontrol edin ve güncel durumu görmek için listeyi yenileyin.",
  "streams.unused": "Kullanılmayan yayınlar: {count}",
  "streams.unusedHint": "Yayın veya tekrar kaydı yok. Listeyi düzenlemek için arşivleyin; hiçbir şey silinmez.",
  "streams.reviewArchive": "İncele ve arşivle",
  "streams.loading": "Yayınlar yükleniyor…",
  "streams.archiveEmpty": "Arşiv boş. Arşivlenen yayınlar ve tekrarları, siz geri yükleyene kadar burada kalır.",
  "streams.restore": "Geri yükle",
  "streams.firstTitle": "İlk yayınınızı oluşturun",
  "streams.firstBody": "Satış, ders veya hizmet için bir kurulum seçin ya da boş yayınla başlayın. Tarayıcı, telefon veya OBS ile yayın yapın.",
  "streams.blank": "Boş yayın",
  "streams.broadcasts": "Yayınlar: {count}",
  "streams.replays": "Tekrarlar: {count}",
  "streams.sessions": "Oturumlar: {count}",
  "streams.recordings": "Kayıtlar: {count}",
  "streams.mode.BROADCAST": "Yayın",
  "streams.mode.LOW_LATENCY": "Düşük gecikme",
  "streams.mode.REALTIME": "Gerçek zamanlı",
  "streams.key": "Anahtar",
  "streams.archiveTitle": "Kullanılmayan yayınları arşivle",
  "streams.archiveHint": "Bu yayınlar hiç başlamadı. Arşivlenen sekmesinden istediğiniz zaman geri yükleyebilirsiniz.",
  "streams.archiveFailed": "{count} yayın arşivlenemedi; canlı yayına geçmiş olabilirler. Diğerleri arşivlendi.",
  "streams.archiving": "Arşivleniyor…",
  "streams.archiveCount": "{count} yayını arşivle",
  "streamType.webinar": "İş webinarları ve lansmanlar",
  "streamType.classroom": "Dersler ve özel ders",
  "streamType.training": "Kurumsal eğitim",
  "streamType.conference": "Konferanslar ve sergiler",
  "streamType.shopping": "Canlı alışveriş",
  "streamType.auction": "Canlı açık artırmalar",
  "streamType.consultation": "Özel danışmanlık",
  "streamType.creator": "İçerik üreticisi ve topluluk yayınları",
  "streamType.audio": "Ses odaları ve podcastler",
  "streamType.sports": "Spor ve e-spor",
  "streamType.performance": "Konserler ve gösteriler",
  "streamType.community": "İbadet ve bağış toplama",
  "streamType.tour": "Turlar ve tanıtımlar",
  "streamType.fitness": "Fitness ve atölyeler",
  "streamType.public-meeting": "Haberler ve halka açık toplantılar",
  "streamType.continuous": "Kesintisiz kanallar ve kameralar",
  "streams.close": "Kapat",
};
